import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Container from "@mui/material/Container";

const useStyles = ({ background, height }) =>
  makeStyles(theme => ({
    root: {
      marginTop: theme.spacing(4),
      display: "flex",
      flexDirection: "column",
      height: height || "100%",
      border: `3px ${background} solid` || "3px transparent solid",
      borderRadius: "20px",
      background: background || "transparent",
      padding: "0",
    },
  }));

const ApplicationPanel = ({ id, children, background, height }) => {
  const classes = useStyles({ background, height })();

  return (
    <Container
      id={id}
      classes={{
        root: classes.root,
      }}
    >
      {children}
    </Container>
  );
};

export default ApplicationPanel;
